export const INCLUSIONS_TITLE_STANDARD = 'standard inclusions'
/**
 * Marketing change/update - with LuxPlus+ being introduced, bonus inclusions are now called "extra inclusions"
 * and LuxPlus+ inclusions are now referred to as "bonus inclusions" 😢
 */
export const INCLUSIONS_TITLE_BONUS = 'extra inclusions'
/**
 * Now referred to as "bonus inclusions"
 */
export const INCLUSIONS_TITLE_LUXPLUS = 'bonus inclusions'

/**
 * Map: icon name -> inclusion type string
 *
 * Context:
 * - svc-search uses standardised inclusion type names in filters (e.g., 'Resort credit', 'Airport transfer')
 * - Multiple inclusion categories from svc-search map to the same filter value:
 *   - 'Generic Credit' (icon: plane_with_plus) → 'Resort credit'
 *   - 'Spa Credit' (icon: lotus_with_plus) → 'Resort credit'
 *   - 'Dining Credit' (icon: crossed_utensils_with_plus) → 'Resort credit'
 *   - 'Daily Dining Credit' (icon: dollar_sign_in_circle) → 'Resort credit'
 *
 * How it works:
 * - When a user has an active filter (e.g., 'Resort credit'), it's stored in redux as that string value
 * - tileInclusions (App.OfferInclusion) only have a `symbol` field (icon name), not a `category` field
 * - We use the icon symbol as a proxy for category: look up the icon (e.g., 'plane_with_plus') in this map
 *   to get the inclusion type ('Resort credit'), then check if it matches the active filter value
 * - This allows us to boost all inclusions that map to 'Resort credit' to the top (see reorderTileInclusionsByActiveFilters)
 *
 * Limitation:
 * - This is a workaround because tileInclusions lacks a category field
 * - We can use icon as proxy because one icon is not used for inclusions of different parent categories
 * - Ideally, we should add a category field to tileInclusions from offer/public-offer
 */

export const inclusionIconMap: Partial<Record<App.OfferFeatureSymbol, string>> = {
  check: 'Default',
  coffee: 'Breakfast',
  coffee_cup: 'Breakfast',
  cloche: 'All-inclusive dining',
  crossed_utensils: 'Daily dining',
  apple: 'Snacks',
  plane_with_plus: 'Resort credit',
  lotus_with_plus: 'Resort credit',
  crossed_utensils_with_plus: 'Resort credit',
  dollar_sign_in_circle: 'Resort credit',
  wine_glass_and_beer_glass: 'Free-flow drinks',
  wine_glass_with_clock: 'Free-flow drinks',
  wine_glass: 'Welcome Drink',
  drink_tray: 'Complementary minibar',
  martini_glass: 'Daily drink',
  plane_with_arrows: 'Roundtrip Domestic Flights',
  taxi: 'Airport transfer',
  car: 'Private VIP Transfer',
  plane_with_arrow: 'One-Way Domestic Flight',
  lotus: 'Spa treatment',
  bed_with_upwards_arrow: 'Seat with plane',
  clock_with_plus: 'Late checkout/early check-in',
  clock_with_check: 'Late checkout/early check-in',
  childs_face: 'Kids stay free',
  childs_face_with_plus: 'Kids stay free',
  ski_lift: 'Lift Pass',
  bus: 'Shuttle',
  wifi_signal: 'Wi-Fi',
  tennis_ball: 'Resort Activities',
  golf: 'Golf',
  p_in_circle: 'Parking',
  seat_with_plane: 'Lounge access',
  receipt: 'Taxes Included',
  tag: 'Discount',
  dollar_sign_in_circle_with_line_through: 'Waived Resort Fees',
}
